module.exports = __webpack_public_path__ + "img/3.4625c65c.svg";